import { useHistory, useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function useRouteSync(to) {
  const { replace } = useHistory();
  const { pathname } = useLocation();

  useEffect(() => {
    if (to && pathname !== to) {
      replace(to);
    }
  }, [to, pathname, replace]);

  return null;
}
